var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bypassConfirmationMessage)?_c('span',[_c('gl-sprintf',{attrs:{"message":_vm.bypassConfirmationMessage},scopedSlots:_vm._u([{key:"strong",fn:function({ content }){return [_c('strong',[_vm._v(_vm._s(content))])]}}],null,false,3347598221)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }